import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getAllQueryParams, getProfileId } from 'utils'
import { loadProfile } from 'actions/profile-actions'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { MessageTypes } from 'constants/message-screens'
import UserMessageFullScreen from 'components/screens/UserMessageFullScreen'
import LoadingSpinnerWithContainer from 'components/generic/LoadingSpinnerWithContainer'
import ResultsSummarySection from 'components/chart/ResultsDoughnutChart/ResultsSummarySection'
import { GameType } from 'components/chart/ResultsDoughnutChart/ResultsDoughnutChartTypes'
import InfoBoxContainer from 'components/generic/InfoBoxContainer'
import { PersonIDInput } from 'types/global'

const WinLossRatio = () => {
  const {
    playerId,
    tennisId,
    defaultGameType,
    showTitle,
    showSubTitle,
    showGameTypeSelector,
    showDateFilter,
    defaultStartDateInput,
  } = useMemo(() => {
    const params = getAllQueryParams()
    return {
      playerId: params['id'],
      tennisId: params['tennis-id'],
      defaultGameType: params['gameType'] as GameType,
      showTitle: params['showTitle'] === 'true',
      showSubTitle: params['showSubTitle'] === 'true',
      showGameTypeSelector: params['showGameTypeSelector'] === 'true',
      showDateFilter: params['showDateFilter'] === 'true',
      defaultStartDateInput: params['startDate'] ? params['startDate'] : undefined,
    }
  }, [])
  const dispatch = useDispatch()
  const { t: tProfile } = useTranslation('strProfile')

  const loadedProfile = useSelector((state: AppState) => state.profile.loadedProfile)
  const profileError = useSelector((state: AppState) => state.profile.profileError)
  const errorType = useSelector((state: AppState) => state.profile.profileErrorType)

  useEffect(() => {
    if (playerId || tennisId) {
      const personIDInput: PersonIDInput = getProfileId(playerId, tennisId)
      dispatch(loadProfile({ id: personIDInput.identifier, type: personIDInput.type }))
    }
  }, [dispatch, playerId, tennisId])

  if (profileError)
    return (
      <UserMessageFullScreen
        messageType={errorType}
        error={errorType !== MessageTypes.PLAYER_NOT_FOUND ? profileError : undefined}
      />
    )

  if (!loadedProfile) {
    return <LoadingSpinnerWithContainer fullScreen spinnerWidth={130} />
  }

  return (
    <InfoBoxContainer>
      <ResultsSummarySection
        title={tProfile('resultsSummary')}
        playerId={loadedProfile.id}
        defaultGameType={defaultGameType}
        showTitle={showTitle}
        showSubTitle={showSubTitle}
        showGameTypeSelector={showGameTypeSelector}
        showDateFilter={showDateFilter}
        defaultStartDateInput={defaultStartDateInput}
      />
    </InfoBoxContainer>
  )
}

export default WinLossRatio
